import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransportationRow } from './TransportationTable';
import { SSN } from 'app/components/Placement/PlacementDetails/Edit/Components/SSN';
import { useSelector } from 'react-redux';
import { selectEditableRequirementTypes } from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { useArrivedFieldsetMeta } from '../useArrivedFieldsetMeta';
import { CustomTooltip } from '@AMIEWEB/Common';

export const TransportationSSN = () => {
  const { t } = useTranslation();
  const { ssn } = useSelector(selectEditableRequirementTypes);
  const fieldsetMeta = useArrivedFieldsetMeta();

  return (
    <TransportationRow
      id="placement-offer-transportation-ssn"
      label={t('placement.profile.summary.offer.transportation.ssn')}
      controlComponent={
        <CustomTooltip disabled={!fieldsetMeta.disabled} tooltipContent={fieldsetMeta.title} placement="bottom-start" arrow={false} isStandardContent>
          <SSN id="ssn-text-field-transportation" disabled={fieldsetMeta.disabled} />
        </CustomTooltip>
      }
      requirement={ssn?.requirement}
    />
  );
};
